<template>
  <div>
    <section class="section-contact container-fluid" id="contact">
      <div class="container my3">
        <div class="row">
          <div class="col-lg-4">
            <div class="box">
              <a class="navbar-brand" href="/">
                <img :src="empresa.logo" alt="" />
                <div class="float-logo">
                  <span>{{ empresa.razon_social }}</span><br />
                  <span>CONSEJO DEPARTAMENTAL DE SAN MARTÍN</span>
                </div>
              </a>
              <p v-html="empresa.objetivo"></p>
              <p style="font-weight: 500">
                <strong>
                  <i class="fas fa-map-marked-alt"></i> {{ empresa.direccion }},
                  {{ empresa.ubigeo }}.</strong>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="box">
              <h3><i class="fa fa-info-circle mr-2"></i> CONTÁCTENOS</h3>
              <ul class="ul-contact">
                <li class="title">Información de Empresa</li>
                <li>
                  <i class="fa fa-hashtag"></i>
                 <strong>RUC:</strong> {{empresa.ruc}}
                </li>
                <li>
                  <i class="fa fa-phone"></i>
                  <strong>Teléfono:</strong> {{empresa.telefonos}}
                </li>
                <li>
                  <i class="fa fa-envelope"></i>
                  <strong>Correo:</strong> {{empresa.correo}}
                </li>
				<!--
                <li class="title">Escríbenos</li>
                <li>
                  <a href="/contactenos">
                    <i class="fa-solid fa-share-from-square"></i>
                    Contáctenos
                  </a>
                </li>
				-->
                <li class="title">Horario de Atención</li>
                <li>
                  <i class="fa fa-clock"></i>
                  {{ empresa.horario_atencion }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="box">
              <h3><i class="fa fa-newspaper mr-3"></i> FANPAGE</h3>
              <a :href="empresa.fan_page" target="_blank" rel="noopener noreferrer" class="fake-iframe-link">
                <img :src="Institucion.fan_page_consejo" alt="Facebook Fanpage"
                  class="fake-iframe-image" />
                <div class="fake-iframe-content">
                  <strong class="mb-3">{{ empresa.razon_social }}</strong>
                  <br />
                  <br />
                  <div class="fake-iframe-buttons">
                    <a href="https://www.facebook.com/share/1HFmSNx3qd/?mibextid=wwXIfr" target="_blank" class="follow-button"><i class="fab fa-facebook"></i></a>
                    <a href="https://www.facebook.com/share/1HFmSNx3qd/?mibextid=wwXIfr" target="_blank" class="share-button"><i class="fa fa-share text-brown"></i></a>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer>
      <div class="container-fluid footer">
        <div class="container py-3">
          <div class="row">
            <div class="col d-flex justify-content-between">
              <div class="col-md-6">
                {{ empresa.abreviatura }} CDSM Tarapoto © Copyright 2024
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <button v-show="showScrollTop" @click="scrollToTop" class="scroll-to-top visible">
      <i class="fas fa-chevron-up"></i>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "FootBar",
  data() {
    return {
      showScrollTop: false,
      Institucion: [],

    };
  },
  computed: {
    ...mapState(["loading", "empresa"]),
  },
  methods: {
    ...mapMutations(["setLoading"]),
    ...mapActions(["loadObjEmpresa"]),
    getAbout() {
      this.setLoading(true);
      this.$http.get("ws_principal/property_company").then((res) => {
        this.Institucion = res.data.Institucion;
        console.log(this.Institucion)
      });
    },
    scrollToTop() {
      const scrollStep = -window.scrollY / (500 / 15);
      const scrollInterval = setInterval(() => {
        if (window.scrollY !== 0) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
    },
    checkScroll() {
      this.showScrollTop = window.scrollY > 100;
    },
  },
  mounted() {
    this.loadObjEmpresa(), window.addEventListener("scroll", this.checkScroll);
    this.getAbout();

  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.checkScroll);
  },
};
</script>
